import {Directive, ElementRef, OnInit, Renderer2} from '@angular/core';
import {ConfigLoaderService} from '../../../app-loader/config-loader.service';
import {PlatformConfig} from '../../../app-loader/platform-config';

@Directive({
  selector: '[appAppColor]'
})
export class AppColorDirective implements OnInit {

  private platformConfig: PlatformConfig;

  constructor(private renderer: Renderer2, private el: ElementRef, private configLoader: ConfigLoaderService) {
    this.platformConfig = configLoader.getPlatformConfig();
  }

  ngOnInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'background-color', this.platformConfig.platform.callcenterAppColor);
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/directives/app-color/app-color.directive.ts